export default {"src":"/_next/static/media/values_about.cc56211d.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};